export default __webpack_public_path__ + "static/media/img-slider-banpu-5.c790d2e3.png";